'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'user-headset';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f82d';
var svgPathData = ['M8 512c4.4 0 8-3.6 8-8 0-75.1 60.9-136 136-136l144 0c75.1 0 136 60.9 136 136 0 4.4 3.6 8 8 8L8 512zM128 160c0-50.1 38.3-91.2 87.2-95.6 2.9-.2 5.8-.4 8.8-.4s5.9 .1 8.8 .4c48.9 4.5 87.2 45.6 87.2 95.6 0 12.4-2.3 24.2-6.6 35-16-12-35.9-19-57.4-19l-64 0c-21.5 0-41.4 7.1-57.4 19-4.3-10.9-6.6-22.7-6.6-35z', 'M224 8C140.1 8 72 76.1 72 160l0 24c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-24C56 67.2 131.2-8 224-8S392 67.2 392 160l0 152c0 4.4-3.6 8-8 8l-192 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l64 0c26.5 0 48 21.5 48 48 0 12.3-4.6 23.5-12.2 32l84.2 0 0-144C376 76.1 307.9 8 224 8zm32 296c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0zm64-144c0-53-43-96-96-96s-96 43-96 96c0 12.4 2.3 24.2 6.6 35-4.5 3.4-8.7 7.2-12.6 11.3-6.4-14.1-10-29.8-10-46.3 0-61.9 50.1-112 112-112S336 98.1 336 160c0 16.5-3.6 32.2-10 46.3-3.9-4.1-8.1-7.9-12.6-11.3 4.3-10.9 6.6-22.7 6.6-35zM16 504c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-83.9 68.1-152 152-152l144 0c83.9 0 152 68.1 152 152 0 4.4-3.6 8-8 8s-8-3.6-8-8c0-75.1-60.9-136-136-136l-144 0C76.9 368 16 428.9 16 504z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserHeadset = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;